import { render, staticRenderFns } from "./SignupNoteCaption.vue?vue&type=template&id=6308e14c&scoped=true&"
import script from "./SignupNoteCaption.vue?vue&type=script&lang=ts&"
export * from "./SignupNoteCaption.vue?vue&type=script&lang=ts&"
import style0 from "./SignupNoteCaption.vue?vue&type=style&index=0&id=6308e14c&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6308e14c",
  null
  
)

export default component.exports